import React, { Component } from 'react';
import { connect } from 'react-redux';

import Pagination from './pagination';

class CompanyList extends Component {

	addHttpToLink( link ) {
		return link.includes( 'http' ) ? link : `http://${link}`;
	}

	renderCompanies() {
		let filteredMembers = this.props.members.filter( member => {
			return member.company.toLowerCase()
			             .includes( this.props.searchTerm.toLowerCase() );
		} );

		if ( [
				'primary', 'associate', 'subscriber'
			].includes( this.props.memberType ) ) {
			filteredMembers = filteredMembers.filter( member => {
				return member.type.toLowerCase()
				             .includes( this.props.memberType.toLowerCase() );
			} );
		}

		this.totalCount = filteredMembers.length;

		if ( parseInt( this.props.pageCount ) ) {
			let start = (this.props.pageNum - 1
			            ) * this.props.pageCount; // Zero-based index at which to begin extraction.
			let end = (this.props.pageNum * this.props.pageCount
			); // Zero-based index before which to end extraction. slice extracts up to but not including end.
			filteredMembers = filteredMembers.slice( start, end );
		}

		return filteredMembers.map( ( member, ind ) => {
			return (<div key={ ind } className="two-col-content-panel">
					<div className="col-sm-3 hidden-xs">
						{ member.type }
					</div>
					<div className="col-sm-9">
						<h4><a className="color-gold" href={ this.addHttpToLink( member.link ) } target="_blank">{ member.company }</a></h4>
					</div>
				</div>
			);
		} );
	}

	render() {
		return (<div className="member-list-companies container">
				{ this.renderCompanies() }
				<Pagination totalCount={ this.totalCount } />
			</div>
		);
	}
}

function mapStateToProps( { members, searchTerm, memberType, pageCount, pageNum } ) {
	return { members, searchTerm, memberType, pageCount, pageNum };
}

export default connect( mapStateToProps, null )( CompanyList );
